import './style.scss';
import {gsap} from 'gsap';
import {Flip} from 'gsap/Flip';

gsap.registerPlugin(Flip);

export function our_brands_block() {
  const block = document.querySelector('.our_brands_block');
  if (!block) return;
  
  const images = Array.from(
      block.querySelectorAll('.images-slider-wrapper .card-image'));
  const logos = Array.from(block.querySelectorAll('.logos-wrapper .logo-item'));
  const texts = Array.from(block.querySelectorAll('.text-wrapper .text-item'));
  const leftArrows = Array.from(
      block.querySelectorAll('.arrows-wrapper .left-arrow'));
  const rightArrows = Array.from(
      block.querySelectorAll('.arrows-wrapper .right-arrow'));
  
  if (!images.length || !logos.length || !texts.length) return;
  
  let active = Math.max(0,
      images.findIndex(el => el.classList.contains('active')));
  const count = images.length;
  const clamp = (i) => (i + count) % count;
  
  function setArrowState() {
    const isFirst = active === 0;
    const isLast = active === count - 1;
    leftArrows.forEach(a => a.classList.toggle('inactive', isFirst));
    rightArrows.forEach(a => a.classList.toggle('inactive', isLast));
  }
  
  function paintImages() {
    images.forEach((el, i) => {
      el.classList.remove('active', 'left-stack', 'right-stack', 'hidden-img');
      if (i === active) el.classList.add('active');
      else if (i < active) el.classList.add('right-stack', 'hidden-img'); // older -> shrink away
      else el.classList.add('left-stack');                                 // upcoming -> small visible
    });
  }
  
  // only touch TWO items (prev & next) while animating; everything else stays hidden
  function slideStacks(stacks, prev, next) {
    stacks.forEach((list) => {
      const prevEl = list[prev];
      const nextEl = list[next];
      if (!prevEl || !nextEl) return;
      
      // reset classes for everyone first
      list.forEach((el, idx) => {
        el.classList.remove('is-current', 'is-above', 'is-below');
        // set the “resting” states relative to 'next'
        if (idx === next) el.classList.add('is-current');
        else if (idx > next) el.classList.add('is-above');
        else el.classList.add('is-below');
      });
      
      // TEMP overlay to avoid overlap glitches:
      // bring nextEl above prevEl, and make prevEl visible during its exit.
      // we only set minimal inline styles and remove them after.
      prevEl.style.visibility = 'visible';
      nextEl.style.visibility = 'visible';
      prevEl.style.zIndex = '1';
      nextEl.style.zIndex = '2';
      
      // cleanup after CSS transition completes
      const cleanup = () => {
        prevEl.style.visibility = '';
        nextEl.style.visibility = '';
        prevEl.style.zIndex = '';
        nextEl.style.zIndex = '';
        nextEl.removeEventListener('transitionend', cleanup);
      };
      nextEl.addEventListener('transitionend', cleanup);
      
      // NOTE: no manual transforms here — your SCSS handles the slide
      // via .is-current / .is-above / .is-below over the slow duration.
    });
  }
  
  function goTo(nextIdx) {
    const target = clamp(nextIdx);
    if (target === active) return;
    
    const prev = active;
    active = target;
    
    // images first (size change)
    paintImages();
    
    // text + logos with overlay protection
    slideStacks([logos, texts], prev, active);
    
    // arrows
    setArrowState();
  }
  
  // init
  paintImages();
  // normalize stacks relative to current
  [logos, texts].forEach(list => {
    list.forEach((el, i) => {
      el.classList.remove('is-current', 'is-above', 'is-below');
      if (i === active) el.classList.add('is-current');
      else if (i > active) el.classList.add('is-above');
      else el.classList.add('is-below');
    });
  });
  setArrowState();
  
  // bind
  rightArrows.forEach(
      btn => btn.addEventListener('click', () => goTo(active + 1)));
  leftArrows.forEach(
      btn => btn.addEventListener('click', () => goTo(active - 1)));
  
  
  
  // assumes gsap + Flip are loaded
  const title = block.querySelector('.title');
  const titleSvg = block.querySelector('.title svg');
  const state = Flip.getState(title);
  
  gsap.set(title, {
    position: "fixed",
    top: "50%", left: "50%",
    xPercent: -50, yPercent: -50,
    zIndex: 10,
    rotation: 0,
    scale: 3.5,
    transformOrigin: "50% 50%"
  });

  gsap.timeline({delay:2})
      .from(titleSvg, {width:'10vmax'})
      .from(title.querySelector('span'), {opacity:0},'<')
      .add(Flip.to(state, {
        ease: "power3.out",
        absolute: true,
        scale: true,
        zIndex:10,
        duration: 1.5
      }), "+=.5")
      .to(title.querySelector('svg'), {opacity:0},'<')
      .from('.right-content-wrapper, .left-content-wrapper > *:not(.title)',{opacity:0, duration:1},'<+=50%')
}
